import { useEffect, useState } from "react";
import { publicApi } from "../lib/api";
import { useLenis } from "../lib/useLenis";
import { DEFAULT_SITE_DATA } from "../constants/defaultSiteData";
import SEO from "../components/site/SEO";
import Navbar from "../components/site/Navbar";
import ContactRail from "../components/site/ContactRail";
import PageHero from "../components/site/PageHero";
import DedicatedCTA from "../components/site/DedicatedCTA";
import { Storytelling } from "../components/site/Sections2";
import { Work as WorkSection, Solutions } from "../components/site/Sections3";
import { GrowthCheck, Clients, Footer } from "../components/site/Sections5";

export default function Work() {
  useLenis();
  const [data, setData] = useState(DEFAULT_SITE_DATA);

  useEffect(() => {
    publicApi.get("/site").then((r) => {
      if (r.data?.content) setData(r.data);
    }).catch(() => {});
  }, []);

  const c = data?.content || DEFAULT_SITE_DATA.content;

  return (
    <div className="bg-white min-h-screen flex flex-col" data-testid="work-page">
      <SEO
        title="Work & Portfolio | Client Campaigns, Commercial Films & Case Studies"
        description="Explore ADMALL INDIA's portfolio of brand identities, cinematic commercials, performance marketing funnels, and enterprise client case studies."
        canonical="https://admallindia.com/work"
      />
      <Navbar logo={c.logo_url} />
      <ContactRail settings={c.settings} />

      <main className="flex-grow">
        <PageHero
          category="Portfolio"
          categoryLink="/work"
          title="Campaigns That Command Market Attention"
          tagline="We judge our work by brand distinctiveness and commercial response. Explore our portfolio of commercial video productions, identity overhauls, and client growth engines."
          bgImage="https://images.unsplash.com/photo-1781127445118-8140677fdea1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          ctaLabel="Discuss A Project"
          ctaHref="/contact"
        />

        <WorkSection caseStudies={data?.case_studies} />
        <Storytelling data={c.storytelling} />
        <Solutions solutions={data?.solutions} />
        <GrowthCheck data={c.growth_check} />
        <Clients data={c.clients} />

        <DedicatedCTA
          title="Ready to showcase your brand at its best?"
          subtitle="Whether you need a cinematic commercial video, high-conversion landing page, or multi-channel acquisition campaign, our studio delivers."
          source="work_page"
        />
      </main>

      <Footer content={c} />
    </div>
  );
}
